/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AccountStatusReasonBody
 */
export interface AccountStatusReasonBody {
    /**
     * Why the account is being disabled or enabled. Stored on the account and in its history.
     * @type {string}
     * @memberof AccountStatusReasonBody
     */
    reason: string;
}

/**
 * Check if a given object implements the AccountStatusReasonBody interface.
 */
export function instanceOfAccountStatusReasonBody(value: object): value is AccountStatusReasonBody {
    if (!('reason' in value) || value['reason'] === undefined) return false;
    return true;
}

export function AccountStatusReasonBodyFromJSON(json: any): AccountStatusReasonBody {
    return AccountStatusReasonBodyFromJSONTyped(json, false);
}

export function AccountStatusReasonBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountStatusReasonBody {
    if (json == null) {
        return json;
    }
    return {
        
        'reason': json['reason'],
    };
}

export function AccountStatusReasonBodyToJSON(json: any): AccountStatusReasonBody {
    return AccountStatusReasonBodyToJSONTyped(json, false);
}

export function AccountStatusReasonBodyToJSONTyped(value?: AccountStatusReasonBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'reason': value['reason'],
    };
}

